const envConfig = {
  baseUrl_node: "http://212.38.94.202:5000",
};
export default envConfig;

// const envConfig = {
//   baseUrl_node: "http://localhost:5000",
// };
// export default envConfig;
